import Modal, { Content } from 'components/Modal';
import { Button } from '@mui/material';
import { Notification } from 'models';
import Markdown from 'components/Markdown';
import { useHistory } from 'react-router-dom';
import { pushAnalyticsEvent } from 'helpers/analytics';
import { StyledContainer, StyledTitle } from './ScheduledPerkModal.styles';

export interface ScheduledPerkModalProps {
  isOpen: boolean;
  onClose: () => void;
  content: Notification;
}

const ScheduledPerkModal = ({ isOpen, onClose, content }: ScheduledPerkModalProps) => {
  const { id, title, description, image: Image, callToAction, path } = content;

  const history = useHistory();

  const handleOnClick = () => {
    if (id === 'win-a-slice') {
      pushAnalyticsEvent({ event: 'winASlice', title: 'Pop Up' });
      history.push({ pathname: path });
    }
    window.open(path, '_blank');
  };

  return (
    <Modal open={isOpen} onClose={onClose} closeType="close" iconColor="dark">
      <Content>
        <StyledContainer>
          <StyledTitle variant="h2">{title}</StyledTitle>

          <Image />

          <Markdown>{description}</Markdown>
          <Button
            fullWidth
            color="primary"
            variant="contained"
            onClick={handleOnClick}
            disableRipple
          >
            {callToAction}
          </Button>
        </StyledContainer>
      </Content>
    </Modal>
  );
};

export default ScheduledPerkModal;
